import { render, staticRenderFns } from "./teacherExamHeader.vue?vue&type=template&id=d0cc5a9e&scoped=true"
import script from "./teacherExamHeader.vue?vue&type=script&lang=js"
export * from "./teacherExamHeader.vue?vue&type=script&lang=js"
import style0 from "./teacherExamHeader.vue?vue&type=style&index=0&id=d0cc5a9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cc5a9e",
  null
  
)

export default component.exports